import Link from "next/link";
import PATHS from "utils/paths";

const TOSNotice = () => {
  return (
    <span className="f7 w-100 lh-copy">
      <span>
        <div>
          By signing up, I accept the PriceBlocs{" "}
          <Link href={PATHS.TERMS}>
            <a className="f7 link color-primary fw5 link__decoration--hover">
              Terms of Service
            </a>
          </Link>{" "}
          and acknowledge the{" "}
          <Link href={PATHS.PRIVACY}>
            <a className="f7 link color-primary fw5 link__decoration--hover">
              Privacy Policy
            </a>
          </Link>
          .
        </div>
      </span>
    </span>
  );
};

export default TOSNotice;
